import React from 'react';
import { CountdownSection } from './CountdownSection';
import { Pricing } from './Pricing';
export function FinalCTA() {
  return <>
      <CountdownSection data-id="element-203" />
      <Pricing data-id="element-204" />

      <footer className="bg-cf-darker py-12 px-4 border-t border-white/10 text-center" data-id="element-205">
        <div className="max-w-4xl mx-auto" data-id="element-206">
          <h3 className="font-bebas text-3xl text-white mb-2" data-id="element-207">
            CROSSFIT RESUELTO™ by RecursosFitness™
          </h3>
          <p className="text-gray-400 mb-8" data-id="element-208">
            El sistema de programación N°1 para instructores de Crossfit en
            Argentina.
            <br data-id="element-209" />
            Porque entrenar crossfit no debería costarte todas las noches de la
            semana.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-cf-gold mb-8" data-id="element-210">
            <a href="#" className="hover:text-white transition-colors" data-id="element-211">
              contacto@recursosfitness.shop
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-212">
              @recursosfitness.ar
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-213">
              recursosfitness.shop
            </a>
          </div>

          <p className="text-xs text-gray-600" data-id="element-214">
            © RecursosFitness.shop™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </footer>
    </>;
}